// Lightweight localStorage helpers for favorite airports
const FAV_KEY = 'abp:favorite_airports';

export function getFavorites() {
  try {
    const raw = localStorage.getItem(FAV_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function isFavorite(code) {
  if (!code) return false;
  return getFavorites().includes(code.toUpperCase());
}

export function toggleFavorite(code) {
  if (!code) return [];
  const upper = code.toUpperCase();
  const current = getFavorites();
  const next = current.includes(upper)
    ? current.filter((c) => c !== upper)
    : [...current, upper];
  localStorage.setItem(FAV_KEY, JSON.stringify(next));
  // Notify same-tab listeners
  window.dispatchEvent(new CustomEvent('abp:favorites-changed', { detail: next }));
  return next;
}

export function subscribeFavorites(callback) {
  const handler = () => callback(getFavorites());
  window.addEventListener('abp:favorites-changed', handler);
  window.addEventListener('storage', (e) => {
    if (e.key === FAV_KEY) handler();
  });
  return () => {
    window.removeEventListener('abp:favorites-changed', handler);
  };
}
